export default { Loading: 'Laster inn' };
